// src/marketing/components/MarketingCTA.js
import React from 'react';
import { Link } from 'react-router-dom';

const MarketingCTA = ({
  title = 'Ready to transform your client experience?',
  subtitle = 'Start your free trial today.',
  primaryButtonText = 'Get Started',
  primaryButtonLink = '/signup',
  secondaryButtonText = 'Contact Sales',
  secondaryButtonLink = '/contact',
  showSecondaryButton = true,
  backgroundColor = 'bg-blue-600 ',
  variant = 'default', // "default", "simple", "centered"
}) => {
  if (variant === 'simple') {
    return (
      <section className={`py-12 ${backgroundColor}`}>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-6">
            {title}
          </h2>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to={primaryButtonLink}
              className="inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-blue-600 bg-white hover:bg-blue-50 transition-colors"
            >
              {primaryButtonText}
            </Link>
            {showSecondaryButton && (
              <Link
                to={secondaryButtonLink}
                className="inline-flex items-center justify-center px-8 py-3 border border-white text-base font-medium rounded-md text-white hover:bg-blue-700 transition-colors"
              >
                {secondaryButtonText}
              </Link>
            )}
          </div>
        </div>
      </section>
    );
  }

  if (variant === 'centered') {
    return (
      <section className={`py-16 ${backgroundColor}`}>
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-4">
            {title}
          </h2>
          <p className="text-xl text-blue-100 mb-8">{subtitle}</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to={primaryButtonLink}
              className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-lg font-medium rounded-md text-blue-600 bg-white hover:bg-blue-50 transition-colors shadow-lg"
            >
              {primaryButtonText}
            </Link>
            {showSecondaryButton && (
              <Link
                to={secondaryButtonLink}
                className="inline-flex items-center justify-center px-8 py-4 border-2 border-white text-lg font-medium rounded-md text-white hover:bg-blue-700 hover:border-blue-100 transition-colors"
              >
                {secondaryButtonText}
              </Link>
            )}
          </div>
        </div>
      </section>
    );
  }

  // Default variant
  return (
    <section className={`py-16 ${backgroundColor}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="lg:flex lg:items-center lg:justify-between">
          <div className="mb-8 lg:mb-0">
            <h2 className="text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
              <span className="block">{title}</span>
              <span className="block text-blue-200">{subtitle}</span>
            </h2>
          </div>
          <div className="flex flex-col sm:flex-row gap-4 lg:flex-shrink-0">
            <Link
              to={primaryButtonLink}
              className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-blue-600 bg-white hover:bg-blue-100 transition-colors shadow-lg dark:bg-gray-700 dark:text-white  dark:hover:bg-gray-600"
            >
              {primaryButtonText}
            </Link>
            {showSecondaryButton && (
              <Link
                to={secondaryButtonLink}
                className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-800 hover:bg-blue-600 transition-colors hover:text-white shadow-lg dark:hover:text-white "
              >
                {secondaryButtonText}
              </Link>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default MarketingCTA;
